import type { Board } from "../board";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class CycleDigit extends PhysicalThing implements ProcessableThing {
	static key = "CycleDigit";
	private digit: number;
	private turnsPerIncrement: number;
	private counter: number = 0;

	constructor(xy: XY, digit: number = 0, turnsPerIncrement: number = 5) {
		super(xy, false);
		this.digit = digit;
		this.turnsPerIncrement = turnsPerIncrement;
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	processTurn(_board: Board): void {
		this.counter++;
		if (this.counter >= this.turnsPerIncrement) {
			this.counter = 0;
			this.digit = (this.digit + 1) % 10;
		}
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			digit: this.digit,
			turnsPerIncrement: this.turnsPerIncrement,
			counter: this.counter,
		};
	}

	static deserialize(data: any): CycleDigit {
		const c = new CycleDigit(deserializeXY(data.xy), data.digit, data.turnsPerIncrement);
		c.visualId = data.visualId;
		c.counter = data.counter ?? 0;
		return c;
	}
}
